export class Competitor {
  id: number;
  name: string;
  itemId: number;
  itemName: string;
  itemBrandId: number;
  itemBrandName: string;
}
